export default __webpack_public_path__ + "img/08a87116b2437e2bcb4663f5b66880d4.svg";